// this is an autogenerated file from DesignSystem/TasksViewForm/mutation-delete-task-assignee.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__DesignSystem_TasksViewForm($task_id: uuid!) {
  delete_tasks_assignees(where: { task_id: { _eq: $task_id } }) {
    affected_rows
  }
}

`